import LoadPayments from "./LoadPayments";

export default LoadPayments;